<script>
import mediaQueries from '@/schemas/mediaQueries';

export default {
  name: 'TeaserImage',

  props: {
    imgSrc: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      mediaQueries,
      imgHeight: this.imgSrc.details.image.height,
      imgWidth: this.imgSrc.details.image.width,
      loadImage: false,
      showImage: false,
    };
  },

  computed: {
    width() {
      return window.innerWidth > mediaQueries.tabletSmall ? 1600 : 800;
    },

    height() {
      return (this.width / this.imgWidth) * this.imgHeight;
    },
  },

  methods: {
    setShowImage() {
      this.showImage = true;
    },

    visibilityChanged({ isVisible }) {
      if (isVisible) {
        this.loadImage = true;
      }
    },
  },

  mounted() {
    if (!('IntersectionObserver' in window)) {
      this.loadImage = true;
    }
  },
};
</script>

<template>
  <div
    class="image-wrapper"
    :style="`width: ${width}px`"
    :class="{ show: showImage }"
    v-observe="visibilityChanged"
  >
    <img
      v-if="loadImage"
      @load="setShowImage"
      :src="`${imgSrc.url}?w=${width}&fl=progressive`"
      alt=""
    />
  </div>
</template>

<style lang="scss" scoped>
.image-wrapper {
  max-width: 100%;
  opacity: 0;
  transition: opacity $transition;

  img {
    max-width: 100%;
  }

  &.show {
    opacity: 1;
  }
}
</style>
